module.exports = __webpack_public_path__ + "static/img/title@2x.dcdd9485.png";